import { faEnvelope, faMessage, faPhone } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import CopyButton from "components/common/button/CopyButton"
import ComponentState, { ComponentStateTypes } from "components/common/ComponentState"
import HTMLCode from "components/common/HTMLCode"
import Translate from "components/common/Translate"
import PropertyView from "components/common/views/PropertyView"
import { useEffect, useState } from "react"
import { Maybe } from "types/graphql"
import { getPersonData, PersonContactType, PersonQueryResponseToPersonType, PersonType } from "types/person-types"
import If from "../../../common/If";
type PersonViewPropsType = {
    model: number | string | PersonType
}

const PersonView = (props: PersonViewPropsType) => {
    const [model, setModel] = useState<Maybe<PersonType>>(typeof props.model === 'object' ? props.model : null);
    const [state, setState] = useState<ComponentStateTypes>(typeof props.model === 'object' ? '' : 'loading');

    // #region init
    useEffect(() => {
        const id = Number(props.model)
        if (id) {
            setState('loading');
            readData(id).then();
        } else if (typeof props.model === 'object') {
        } else {
            setState('error.not-valid-id');
        }
    }, [props.model]);

    const readData = async (id: number) => {
        const response = await getPersonData(id);
        try {
            if (response.errors) {
                setState(response.errors.map(c => c.message).join(", "));
            } else if (response.data?.person) {
                setModel(PersonQueryResponseToPersonType(response));
                setState('');
            } else {
                setState('nodata');
            }
        } catch (error: any) {
            console.error(error);
            setState('error');
        }
    }
    // #endregion init

    const getContactLink = (contact: PersonContactType) => {
        if (contact.link) {
            return <a href={contact.link}>{contact.value}</a>;
        }
        const items = [
            <span key={`person-view-value-action-${contact.id}`}>{contact.value}</span>,
            <HTMLCode key={`person-view-space-1-action-${contact.id}`} />,
            <HTMLCode key={`person-view-space-2-action-${contact.id}`} />,
            <HTMLCode key={`person-view-space-3-action-${contact.id}`} />
        ];
        switch (contact.type) {
            case 'email':
                items.push(<a title="sendmail" key={`person-view-email-action-${contact.id}`} className="btn link" href={`mailto:${contact.value}`}><FontAwesomeIcon icon={faEnvelope} /></a>);
                break;
            case 'tel':
                items.push(<a title="call" key={`person-view-tel-action-${contact.id}`} className="btn link" href={`tel:${contact.value}`}><FontAwesomeIcon icon={faPhone} /></a>);
                items.push(<a title="call" key={`person-view-sms-action-${contact.id}`} className="btn link" href={`sms:${contact.value}`}><FontAwesomeIcon icon={faMessage} /></a>);
                break;
        }

        items.push(<CopyButton key={`person-view-copy-action-${contact.id}`} text={contact.value} />);

        return items;
    }

    const renderCountry = () => {
        if(!model?.country) return <></>;
        return <PropertyView label="fields.country.name">
            <div className="flex gap-1">
                <img src={model!.country!.flag} alt={model!.country!.name} title={model!.country!.name} className="w-6 my-auto"/>
                <span className="pl-2">{model!.country!.translate || model!.country!.name}</span>
                <span className="pl-2">({model!.country?.alpha3Code})</span>
            </div>
        </PropertyView>;
    }

    const renderBody = () => {
        return <div>
            <PropertyView label="fields.id.name" value={model!.id} />
            <PropertyView label="fields.name.name" value={model!.name} />
            {renderCountry()}
            <div className="pt-4">
                <h3>-<HTMLCode/><Translate i18nKey="common.contact"/></h3>
                <hr/>
            </div>
            <div>
                {model?.contactInfo.map(c => {
                    const value = <>{getContactLink(c)}</>;
                    return <PropertyView key={c.id} label={`contact.${c.type}`} value={value} />
                })}
            </div>
            <div>
                <PropertyView label="fields.tags.name" propertyType="string" value={model!.tags.map(x => x.name).join(', ') || '-'} />
            </div>
            <div>
                <PropertyView label="fields.note.name" propertyType="note" value={model!.note} />
            </div>
        </div>;
    }

    return (
        <ComponentState state={state} children={renderBody} />
    );
}

export default PersonView;
